export default __webpack_public_path__ + "static/media/succes.f7bc2660.svg";